export const UpArrow = ({ color = '#333333', size = 16, style = {} }) => {
    return (
        <svg style={style} xmlns="http://www.w3.org/2000/svg" height={size} width={size} viewBox="0 0 12 12">
            <title></title>
            <g fill={color} className="nc-icon-wrapper">
                <polyline points="0.5 8.5 6 2.5 11.5 8.5" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round">
                </polyline>
            </g>
        </svg>
    )
}